import { Box, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import PriceDetail from 'modules/billing/components/PriceDetail'
import { ChargebeeSubscription } from 'modules/billing/lib/prices'

type Props = {
  title: string
  description: string
  isYearly: boolean
  totalPrice: number
  perSeatPrice: number
  currency: string
  seats: number
  minimumSeats: number
  bundleSubscriptionItems: ChargebeeSubscription[]
}

const PriceTag = ({
  title,
  description,
  isYearly,
  totalPrice,
  perSeatPrice,
  currency,
  seats,
  minimumSeats,
  bundleSubscriptionItems,
}: Props) => {
  const commonProps = {
    currency,
    isYearly,
    minimumSeats,
    perSeatPrice,
    seats,
    totalPrice,
    bundleSubscriptionItems,
  }
  const {
    company: { subscription },
  } = useCurrentSession()

  return (
    <Box>
      <Box style={{ position: 'relative' }}>
        <Box gap="s4" padding="s24" paddingBottom="s0">
          <Text.Header2>{title}</Text.Header2>
          <Text.Normal lineClamp={3}>{description}</Text.Normal>
        </Box>
        {subscription.inFreeTrial ? (
          <PriceDetail.Trial {...commonProps} />
        ) : (
          <PriceDetail.Customer {...commonProps} />
        )}
      </Box>
    </Box>
  )
}

export default PriceTag
